import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import ASQPowerBIReport from '../../../../common/components/molecules/ASQPowerBIReport';
import { expirationTokenInterval, useArrivalReportsQuery } from '../../../../common/hooks/backend';
import { getReportChangeListenerForFiltersAndSlicers } from '../../../../common/utils/power-bi-filters';
import { Module } from '../../../../core/enums/module.enum';
import { withFeatureFlag } from '../../../../core/featureFlags/FeatureFlag';
import { FeatureFlagKey } from '../../../../core/featureFlags/featureFlagKeys';
import { useSetCurrentPowerBiFilters } from '../../../../core/powerBi/hooks';
import DashboardHeader from '../../dashboards/components/molecules/DashboardHeader';
import { getArrivalInfoMessageTranslateKey, getArrivalTitleTranslateKey, useArrivalDashboard } from '../dashboards';

function Dashboards(): ReactElement {
  const { t } = useTranslation('Arrival');

  const {
    dashboard,
    pageName,
    onPageChange,
    onSlicerChange,
    onButtonClick,
    synchronizeAirportCodeAndSubscriptionAndPeriod,
  } = useArrivalDashboard(Module.Arrival);

  const { data: embedRequest, isLoading } = useArrivalReportsQuery(undefined, {
    pollingInterval: expirationTokenInterval,
  });

  const infoMessageTranslateKey = getArrivalInfoMessageTranslateKey(dashboard);

  const [, setCurrentPowerBiFilters] = useSetCurrentPowerBiFilters();
  const onRendered = getReportChangeListenerForFiltersAndSlicers(setCurrentPowerBiFilters);

  return (
    <>
      {dashboard !== null && (
        <DashboardHeader
          title={t(getArrivalTitleTranslateKey(dashboard))}
          infoMessage={infoMessageTranslateKey !== null ? t(infoMessageTranslateKey) : undefined}
        />
      )}
      <ASQPowerBIReport
        embedRequest={embedRequest}
        isLoading={isLoading}
        pageName={pageName ?? undefined}
        onPageChange={onPageChange}
        onLoaded={synchronizeAirportCodeAndSubscriptionAndPeriod}
        onSlicerChange={onSlicerChange}
        onButtonClick={onButtonClick}
        onRendered={onRendered}
        showFilters
      />
    </>
  );
}

const DashboardsFeature = withFeatureFlag(Dashboards, FeatureFlagKey.ArrivalReports);

export default DashboardsFeature;
